<app-dialog
  [isVisible]="isDialogVisible"
  [settings]="{
    showCustomHeader: true,
    showCustomFooter: true,
    closeOnEscape: true,
    isDraggable: ['draggable', 'all'].includes(dialogType),
    isResizable: true,
    isMaximizable: ['maximizable', 'all'].includes(dialogType),
    width: '95vw',
    maxWidth: dialogType === 'simple' ? '532.8px' : ''
  }"
  [emitOnHide]="true"
  (onHide)="handleDialogClose()"
>
  <div dialog-header>
    <div class="flex gap-spacing-xs align-items-center">
      <span class="p-dialog-title text-primary-color title-small-bold"
        >{{ isChangePasswordON() ? "Change Account Password" : "" }}
      </span>
    </div>
  </div>

  <div dialog-body>
    <div class="flex flex-column gap-spacing-md">
      @if (passwordChanged) {
<div
       
        class="background-muted-success-bg p-spacing-md flex gap-spacing-xs align-items-center"
      >
        <span class="icon-check label-large-regular text-success-color"></span>
        <span class="label-large-regular text-success-color"
          >Your password is updated successfully.</span
        >
      </div>
}

      <!-- Profile Section (Displayed when Change Password is not active) -->
      @if (!isChangePasswordON()) {
<div
       
        class="section-container padding-class flex flex-column gap-spacing-xl table-bg-hover-bg border-neutral-base-primary-bc radius-lg p-spacing-xl justify-content-center align-items-center"
      >
        <div class="flex justify-content-center">
          <img
            src="assets/images/Avatars.png"
            alt="user"
            width="56px"
            height="56px"
          />
        </div>

        <div
          class="details-container flex flex-column justify-content-center align-items-center"
        >
          <span class="body-large-bold text-secondary-color">{{
            this.userName()
          }}</span>
          <span class="text-caption-color label-large-regular">{{
            this.userEmail()
          }}</span>
        </div>

        <div
          class="fixed-button flex justify-content-center align-items-center"
        >
          <app-button
            label="Change Password"
            sizeClass="p-button-sm"
            severity="secondary"
            [outlinedButton]="true"
            (onClick)="openChangePassword()"
          ></app-button>
        </div>
      </div>
}

      <!-- Change Password Section (Displayed when isChangePasswordON is true) -->
      @if (isChangePasswordON()) {
<div
       
        class="section-container flex flex-column gap-spacing-xl table-bg-hover-bg border-neutral-base-primary-bc radius-lg p-spacing-xl justify-content-center align-items-center px-spacing-3xl py-spacing-xl"
      >
        <form
          [formGroup]="changePasswordForm"
          class="container-form gap-spacing-xl flex flex-column w-full"
        >
          <div class="grid">
            <div class="flex flex-column gap-spacing-default col-12">
              <label
                class="input-label label-large-medium required"
                for="oldPassword"
                >Enter old password</label
              >
              <div class="k-input-wrapper">
                <input
                  id="oldPassword"
                  formControlName="oldPassword"
                  class="p-inputtext p-inputtext-sm"
                  type="password"
                  placeholder="Password"
                  pInputText
                />
              </div>
              @if (
                  oldPassword?.errors?.['required'] &&
                  oldPassword?.invalid &&
                  oldPassword?.touched
                ) {
<small
                class="input-helper-text"
               
                >wrong Password</small
              >
}
            </div>
          </div>

          <div class="grid">
            <div class="flex flex-column gap-spacing-default col-12">
              <label
                class="input-label label-large-medium required"
                for="newPassword"
                >Enter New password</label
              >
              <div class="k-input-wrapper">
                <input
                  id="newPassword"
                  formControlName="newPassword"
                  class="p-inputtext p-inputtext-sm"
                  type="password"
                  placeholder="Password"
                  pInputText
                />
              </div>
              @if (
                  newPassword?.errors?.['required'] &&
                  newPassword?.invalid &&
                  newPassword?.touched
                ) {
<small
                class="input-helper-text"
               
                >Your new password must be at least 8 characters.</small
              >
}
            </div>
          </div>
        </form>
      </div>
}
    </div>
  </div>

  <!-- Dialog Footer -->
  <div dialog-footer>
    <div class="flex gap-spacing-xl justify-content-end">
      <app-button
        label="Close"
        sizeClass="p-button-sm"
        severity="secondary"
        (onClick)="handleDialogClose()"
        [outlinedButton]="true"
      ></app-button>

      @if (isChangePasswordON()) {
<app-button
       
        label="Change Password"
        sizeClass="p-button-sm"
        severity="primary"
        (onClick)="onSubmit()"
        [outlinedButton]="false"
      ></app-button>
}
    </div>
  </div>
</app-dialog>
